import { axiosInstance } from "."; // Import the configured Axios instance

// Base URL for API calls
 //const BASE_URL = 'http://localhost:8000/api/users';
 const BASE_URL = 'http://65.1.94.207:8000/api/users';

/** 
 * Added by Dilip Yadav 20-10-2024
 * Saves new airlinesticketsales details.
 * @param {Object} payload - The airlinesticketsales details to be saved.
 * @returns {Promise<Object>} - The response data from the API.
 */
export const saveairlinesticketsalesDetails = async (payload) => {
    try {
        const response = await axiosInstance.post(`${BASE_URL}/save-airlinesticketsales`, payload);
        return response.data; 
    } catch (error) {
        console.error("Error saving airlinse ticket details:", error); 
        throw error; 
    }
}

/** 
 * Added by Dilip Yadav 20-10-2024
 * Fetches the list of airlinesticketsales details for a specific user by ID.
 * @param {string} id - The ID of the user.
 * @returns {Promise<Object>} - The airlinesticketsales details list.
 */
export const getairlinesticketsalesDetailsList = async (id) => {
    try {
        const response = await axiosInstance.get(`${BASE_URL}/get-airlinesticketsales-data/${id}`);
        return response.data; // Return the response data
    } catch (error) {
        console.error("Error fetching airlinse ticket details list:", error); // Log the error
        throw error; // Rethrow the error
    }
}

/**
 * Added by Dilip Yadav 20-10-2024
 * Soft deletes airlinesticketsales details by ID.
 * @param {string} id - The ID of the airlinesticketsales to delete.
 * @returns {Promise<Object>} - The response data from the API.
 */
export const deleteairlinesticketsalesDetails = async (id) => {
    try {
        const response = await axiosInstance.delete(`${BASE_URL}/delete-airlinesticketsales/${id}`);
        return response.data; 
    } catch (error) {
        console.error("Error deleting airlinse ticket  details:", error); 
        throw error; 
    }
};

/**
 * Added by Dilip Yadav 20-10-2024
 * Updates airlinesticketsales details by ID.
 * @param {string} id - The ID of the airlinesticketsales to update.
 * @param {Object} payload - The updated airlinesticketsales details.
 * @returns {Promise<Object>} - The response data from the API.
 */
export const updateairlinesticketsalesDetails = async (id, payload) => {
    try {
        const response = await axiosInstance.put(`${BASE_URL}/update-airlinesticketsales/${id}`, payload);
        return response.data; 
    } catch (error) {
        console.error("Error updating airlinse ticket details:", error);
        throw error;
    }
};
